import { render } from "./ModalAdd.vue?vue&type=template&id=ec1431da&scoped=true"
import script from "./ModalAdd.vue?vue&type=script&lang=js"
export * from "./ModalAdd.vue?vue&type=script&lang=js"

import "./ModalAdd.vue?vue&type=style&index=0&id=ec1431da&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec1431da"]])

export default __exports__